import { default as NotFoundPage } from "../pages/NotFoundPage.vue";

import { AdminRoutes } from "../pages/admin/admin.route";
import { AgentInvoiceRoutes } from "../pages/agent_invoice/agent_invoice.route";
import { AgentPaymentRoutes } from "../pages/agent_payment/agent_payment.route";
import { AgentSettlementRoutes } from "../pages/agent_settlement/agent_settlement.route";
import { AgentSubscriptionRoutes } from "../pages/agent_subscription/agent_subscription.route";
import { APIKeyRoutes } from "../pages/api_key/api_key.route";
import { AssociateRoutes } from "../pages/associate/associate.route";
import { AssociateAgentRoutes } from "../pages/associate_agent/associate_agent.route";
import { AssociateLegalsRoutes } from "../pages/associate_legals/associate_legals.route";
import { AssociateMarketingRoutes } from "../pages/associate_marketing/associate_marketing.route";
import { AssociatePresenceRoutes } from "../pages/associate_presence/associate_presence.route";
import { AssociateRegistrationRoutes } from "../pages/associate_registration/associate_registration.route";
import { AssociateSettingsRoutes } from "../pages/associate_settings/associate_settings.route";
import { AssociateUserRoutes } from "../pages/associate_user/associate_user.route";
import { AssociateWagentRoutes } from "../pages/associate_wagent/associate_wagent.route";
import { AuditProductInternetRoutes } from "../pages/audit_product_internet/audit_product_internet.route";
import { AuditSubscriptionRoutes } from "../pages/audit_subscription/audit_subscription.route";
import { AuditorRoutes } from "../pages/auditor/auditor.route";
import { CustomerRoutes } from "../pages/customer/customer.route";
import { CustomerComplaintRoutes } from "../pages/customer_complaint/customer_complaint.route";
import { CustomerImportRoutes } from "../pages/customer_import/customer_import.route";
import { CustomerInvoiceRoutes } from "../pages/customer_invoice/customer_invoice.route";
import { CustomerRegistrationRoutes } from "../pages/customer_registration/customer_registration.route";
import { DashboardRoutes } from "../pages/dashboard/dashboard.route";
import { DebugToolsRoutes } from "../pages/debug_tools/debug_tools.route";
import { DevToolsRoutes } from "../pages/devtools/devtools.route";
import { FeatureTogglesRoutes } from "../pages/feature_toggles/feature_toggles.route";
import { FinanceAccountRoutes } from "../pages/finance_account/finance_account.route";
import { FinanceDisbursementRoutes } from "../pages/finance_disbursement/finance_disbursement.route";
import { FinanceDisbursementAccountRoutes } from "../pages/finance_disbursement_account/finance_disbursement_account.route";
import { FinanceInvoiceRoutes } from "../pages/finance_invoice/finance_invoice.route";
import { FinancePaymentRoutes } from "../pages/finance_payment/finance_payment.route";
import { FinanceReportRoutes } from "../pages/finance_report/finance_report.route";
import { FinanceTaxRoutes } from "../pages/finance_tax/finance_tax.route.js";
import { HotspotTemplateRoutes } from "../pages/hotspot_template/hotspot_template.route";
import { HotspotVoucherRoutes } from "../pages/hotspot_voucher/hotspot_voucher.route";
import { LegalsRoutes } from "../pages/legals/legals.route";
import { LocationRoutes } from "../pages/location/location.route";
import { MarketingClaimRoutes } from "../pages/marketing_claim/marketing_claim.route";
import { MarketingDisbursementRoutes } from "../pages/marketing_disbursement/marketing_disbursement.route";
import { MarketingInvoiceRoutes } from "../pages/marketing_invoice/marketing_invoice.route";
import { MarketingSubscriptionRoutes } from "../pages/marketing_subscription/marketing_subscription.route";
import { NetworkGroupRoutes } from "../pages/network_group/network_group.route";
import { NetworkOLTRoutes } from "../pages/network_olt/network_olt.route";
import { NetworkONTRoutes } from "../pages/network_ont/network_ont.route";
import { NetworkONTBlockRoutes } from "../pages/network_ont_block/network_ont_block.route.js";
import { NetworkPOPRoutes } from "../pages/network_pop/network_pop.route";
import { NotificationRoutes } from "../pages/notification/notification.route";
import { PrivilegeRoutes } from "../pages/privilege/privilege.route";
import { ProductBroadbandRoutes } from "../pages/product_broadband/product_broadband.route";
import { ProductHotspotRoutes } from "../pages/product_hotspot/product_hotspot.route";
import { ProfileRoutes } from "../pages/profile/profile.route";
import { ProvisionRoutes } from "../pages/provision/provision.route";
import { ProvisionReturnRoutes } from "../pages/provision_return/provision_return.route";
import { RadiusAccountRoutes } from "../pages/radius_account/radius_account.route";
import { RadiusNASRoutes } from "../pages/radius_nas/radius_nas.route";
import { RadiusServerRoutes } from "../pages/radius_server/radius_server.route";
import { ResellerRoutes } from "../pages/reseller/reseller.route";
import { ResellerInvoiceRoutes } from "../pages/reseller_invoice/reseller_invoice.route";
import { ResellerRegistrationRoutes } from "../pages/reseller_registration/reseller_registration.route";
import { SettingsRoutes } from "../pages/settings/settings.route";
import { SkipAuditSubscriptionRoutes } from "../pages/skip_audit_subscription/skip_audit_subscription.route.js";
import { SubscriptionRoutes } from "../pages/subscription/subscription.route";
import { SubscriptionDismantleRoutes } from "../pages/subscription_dismantle/subscription_dismantle.route";
import { SubscriptionProductChangeRoutes } from "../pages/subscription_product_change/subscription_product_change.route";
import { SystemDisbursementRoutes } from "../pages/system_disbursement/system_disbursement.route";
import { WarehouseItemRoutes } from "../pages/warehouse_item/warehouse_item.route";
import { WarehouseItemTypeRoutes } from "../pages/warehouse_item_type/warehouse_item_type.route";
import { WarehouseLocationRoutes } from "../pages/warehouse_location/warehouse_location.route";
import { WhatsAppInvoiceRoutes } from "../pages/whatsapp_invoice/whatsapp_invoice.route.js";
import { WhatsAppMessageRoutes } from "../pages/whatsapp_message/whatsapp_message.route";
import { WhatsAppUsageRoutes } from "../pages/whatsapp_usage/whatsapp_usage.route";

export const routes = [
    {
        path: "/signin",
        component: () => import("../pages/LoginPage.vue"),
    },
    {
        path: "/signup",
        component: () => import("../pages/RegisterPage.vue"),
    },
    {
        path: "/join",
        component: () => import("../pages/associate_registration/AssociateRegistrationSignup.vue"),
    },
    {
        path: "/join/:registrationId",
        component: () => import("../pages/associate_registration/AssociateRegistrationStatus.vue"),
    },
    {
        path: "/payment/:invoiceId",
        component: () => import("../pages/standalone/payment/PaymentPage.vue"),
    },
    {
        path: "/privacy-policy",
        component: () => import("../pages/PrivacyPolicy.vue"),
    },
    {
        path: "/terms-of-service",
        component: () => import("../pages/TermsOfService.vue"),
    },
    {
        path: "/mobile-support",
        component: () => import("../pages/MobileSupportPage.vue"),
    },
    {
        path: "/",
        component: () => import("../pages/MainPage.vue"),
        children: [
            ...AdminRoutes.routes,
            ...AgentInvoiceRoutes.routes,
            ...AgentPaymentRoutes.routes,
            ...AgentSettlementRoutes.routes,
            ...AgentSubscriptionRoutes.routes,
            ...APIKeyRoutes.routes,
            ...AssociateRoutes.routes,
            ...AssociateAgentRoutes.routes,
            ...AssociateLegalsRoutes.routes,
            ...AssociateMarketingRoutes.routes,
            ...AssociatePresenceRoutes.routes,
            ...AssociateRegistrationRoutes.routes,
            ...AssociateSettingsRoutes.routes,
            ...AssociateUserRoutes.routes,
            ...AssociateWagentRoutes.routes,
            ...AuditorRoutes.routes,
            ...AuditProductInternetRoutes.routes,
            ...AuditSubscriptionRoutes.routes,
            ...CustomerComplaintRoutes.routes,
            ...CustomerImportRoutes.routes,
            ...CustomerInvoiceRoutes.routes,
            ...CustomerRegistrationRoutes.routes,
            ...CustomerRoutes.routes,
            ...DashboardRoutes.routes,
            ...FeatureTogglesRoutes.routes,
            ...FinanceAccountRoutes.routes,
            ...FinanceDisbursementRoutes.routes,
            ...FinanceDisbursementAccountRoutes.routes,
            ...FinanceInvoiceRoutes.routes,
            ...FinancePaymentRoutes.routes,
            ...FinanceReportRoutes.routes,
            ...FinanceTaxRoutes.routes,
            ...HotspotTemplateRoutes.routes,
            ...HotspotVoucherRoutes.routes,
            ...LegalsRoutes.routes,
            ...LocationRoutes.routes,
            ...MarketingClaimRoutes.routes,
            ...MarketingDisbursementRoutes.routes,
            ...MarketingInvoiceRoutes.routes,
            ...MarketingSubscriptionRoutes.routes,
            ...NetworkGroupRoutes.routes,
            ...NetworkOLTRoutes.routes,
            ...NetworkONTRoutes.routes,
            ...NetworkONTBlockRoutes.routes,
            ...NetworkPOPRoutes.routes,
            ...NotificationRoutes.routes,
            ...PrivilegeRoutes.routes,
            ...ProductBroadbandRoutes.routes,
            ...ProductHotspotRoutes.routes,
            ...ProfileRoutes.routes,
            ...ProvisionReturnRoutes.routes,
            ...ProvisionRoutes.routes,
            ...RadiusAccountRoutes.routes,
            ...RadiusNASRoutes.routes,
            ...RadiusServerRoutes.routes,
            ...ResellerInvoiceRoutes.routes,
            ...ResellerRegistrationRoutes.routes,
            ...ResellerRoutes.routes,
            ...SkipAuditSubscriptionRoutes.routes,
            ...SubscriptionDismantleRoutes.routes,
            ...SubscriptionProductChangeRoutes.routes,
            ...SubscriptionRoutes.routes,
            ...SystemDisbursementRoutes.routes,
            ...WarehouseItemRoutes.routes,
            ...WarehouseItemTypeRoutes.routes,
            ...WarehouseLocationRoutes.routes,
            ...WhatsAppInvoiceRoutes.routes,
            ...WhatsAppMessageRoutes.routes,
            ...WhatsAppUsageRoutes.routes,
            ...SettingsRoutes.routes,
            ...DevToolsRoutes.routes,
            ...DebugToolsRoutes.routes,
        ],
    },
    {
        path: "/:pathMatch(.*)*",
        component: NotFoundPage,
    },
];
